import React from 'react';
import { useNavigate } from 'react-router-dom';
import foodbrand from '../../assets/foodbrand@2x.png';
import Pantalla2Lic from '../Pantalla2Lic/Pantalla2Lic';
import Header from '../../Header/Header';
import './style.css';

function PantallaBase2Lic() {

    const navigate = useNavigate();

    const onContinue = async () => {
        navigate('/PantallaBase3Lic');
    }

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header imgBack={false} rutaBack='/PantallaBase' title='Licencia de Conducir' />

                <div className='containerRender'>
                    <Pantalla2Lic />
                </div>
                <div className="footer">
                    <div className='containerCont_P2'>
                        <button className='button_P2' onClick={onContinue} >
                            <span className='txtButton_P2'>Iniciar</span>
                        </button>
                        {/* <div className='txtMsj_P2'>Al dar clic en Iniciar, está de acuerdo con que Sistema de Confiabilidad DPR SAPI, guarde la información capturada en línea para posteriormente hacer contacto vía SMS, correo electrónico, WhatsApp o cualquier otro medio de comunicación electrónico con la finalidad de dar seguimiento y estatus de las operaciones realizadas.</div> */}
                    </div>
                    <div className='imageContainer_P2'>
                        <img src={foodbrand} className='imgFooter_P2' />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PantallaBase2Lic